<!-- 
Panel for displaying details of a notice template.
-->
<template>
  <div>
    <div v-if="state.loaded">
      <our-data-container fluid>
        <our-data-field label-width="11" label="Subject">
          {{ subject }}
        </our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container fluid>
        <our-data-field label-width="11" label="Body">
          <code>{{ body }}</code>
        </our-data-field>
      </our-data-container>
    </div>
    <our-loading-indicator v-else />
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/notice-templates/action-types";

export default {
  mixins: [filterMixins, lookupMixins],
  props: {
    levyCollectionId: {
      required: true,
      type: Number
    },
    noticeType: {
      required: true,
      type: String
    }
  },
  computed: {
    state() {
      return this.$store.state.noticeTemplates.view;
    },
    loaded() {
      return this.state.loaded;
    },
    levyCollectionTemplate() {
      return this.state.data;
    },
    subject() {
      return this.levyCollectionTemplate.subject;
    },
    body() {
      return this.levyCollectionTemplate.body;
    }
  },
  watch: {
    levyCollectionId() {
      this.reload();
    },
    noticeType() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    async reload() {
      this.$store.dispatch(action.VIEW_REFRESH, {
        levyCollectionId: this.levyCollectionId,
        noticeType: this.noticeType
      });
    }
  }
};
</script>
